const API = import.meta.env.VITE_API_URL || 'https://api.scrivar.com';

/** Advisory check — POST /codes/check. Returns { ok, status?, tier?, reason? } or null on network error. */
export async function checkCode(code) {
  try {
    const res = await fetch(`${API}/codes/check`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code }),
    });
    if (!res.ok) return null;
    return await res.json();
  } catch { return null; }
}

/** Bind a code to the signed-in account — POST /account/link-code. Returns { ok, status, message }. */
export async function bindCode(idToken, code) {
  try {
    const res = await fetch(`${API}/account/link-code`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
      body: JSON.stringify({ code }),
    });
    const data = await res.json().catch(() => ({}));
    return { ok: res.ok && data.success !== false, status: res.status, message: data.message || '' };
  } catch { return { ok: false, status: 0, message: 'network' }; }
}
